import { utils } from 'components/lexemes';
import Localization, { TrustedValue } from 'lib/localization';

export default {
  lxPagePrivacyPolicyAboutSectionLeftColumnTitle() {
    return Localization.get('bumblesite@privacy.about.title');
  },
  lxPagePrivacyPolicyAboutSectionLeftColumnText1() {
    return Localization.get('bumblesite@privacy.about.text1');
  },
  lxPagePrivacyPolicyAboutSectionLeftColumnText2() {
    return Localization.get('bumblesite@privacy.about.text2', {
      page_badoo_name: 'Badoo',
      terms_url: utils.getLinkMarkerUrl('terms_url'),
    });
  },
  lxPagePrivacyPolicyAboutSectionLeftColumnText3() {
    return Localization.get('bumblesite@privacy.about.text3', {
      __EOL__: TrustedValue.for('<br/>'),
      link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
    });
  },
  lxPagePrivacyPolicyAboutSectionLeftColumnCTA() {
    return Localization.get('bumblesite@privacy.about.contactus');
  },
  lxPagePrivacyPolicyAboutSectionRightColumnTitle() {
    return Localization.get('bumblesite@privacy.goodToKnow');
  },
  lxPagePrivacyPolicyAboutSectionRightColumnText() {
    return Localization.get('bumblesite@privacy.about.goodToKnow.content', {
      link_privacy_policy: utils.getLinkMarkerUrl('link_privacy_policy'),
    });
  },
};
